import { ActionType } from 'typesafe-actions';
import * as contentFragmentActions from './contentFragmentActions';
import BaseReducer, { baseInitialState} from '../../../../../boilerplate/redux/BaseReducer';
import { IBaseStateType } from '../../../../../boilerplate/redux/types/IBaseStateType';

export type ContentFragmentGridAction = ActionType<typeof contentFragmentActions>;

export interface IContentFragmentStateType extends IBaseStateType {
	readonly entryMap: { [queryKey: string]: {} };
	readonly queries: { [queryKey: string]: [] };
}

export function contentFragmentReducer(
	state = baseInitialState as IContentFragmentStateType,
	action: ContentFragmentGridAction,
) {
	const Reducer = new BaseReducer('contentFragmentReducer');

	return Reducer.extend(state, action, (innerState, innerAction) => {
		switch (innerAction.type) {
			case 'OTHER_ACTION_TYPE':
				return Object.assign({}, innerState, {
					data: null,
					done: false,
					error: null,
					loading: true,
				});

			default:
				return innerState;
		}
	});
}

